var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorPressed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_132",
    "data-name": "Grupo 132",
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.653,
    height: 63.653,
    viewBox: "0 0 63.653 63.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_112",
    "data-name": "Grupo 112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_73",
    "data-name": "Rect\\xE1ngulo 73",
    fill: "none",
    stroke: "#e89e9e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.653,
    height: 63.653,
    rx: 5.52,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 62.653,
    height: 62.653,
    rx: 5.02,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_72",
    "data-name": "Rect\\xE1ngulo 72",
    transform: "translate(6.365 6.365)",
    fill: "current",
    stroke: "#e0e0e0",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.922,
    height: 50.922,
    rx: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49.922,
    height: 49.922,
    rx: 1,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPressed);
export default __webpack_public_path__ + "static/media/COLOR_PRESSED.3e1af596.svg";
export { ForwardRef as ReactComponent };